import TransferDetails from 'features/moveMoney/screens/transfer/TransferDetails/TransferDetails';
import React from 'react';

export default function TransferDetailsPage() {
  return <TransferDetails />;
}
